export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/editwatchlist_icon_top@2x.png";